import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';
import myToast from '../Utils/MyToast';
const StudentInformation = (props) => {
  const [current_due, setCurrent_due] = useState('');

  useEffect(() => {
    setCurrent_due(props.current_due);
  }, [props.current_due]);

  if(!props.showStudentInfo)
  {
    return null;
  }
  else{
  return (         
      <div className="animated fadeInUp" style={{margin: '0 0 12px 0'}}>
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '14px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
          overflow: 'hidden',
        }}>
          {/* Student Info Section */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            gap: '12px',
          }}>
            {/* Student Image */}
            <div style={{
              flexShrink: 0,
              position: 'relative',
            }}>
              <div style={{
                width: '72px',
                height: '72px',
                borderRadius: '50%',
                overflow: 'hidden',
                border: '3px solid #fff',
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                background: COLORS.primary_color_shade1,
              }}>
                <img 
                  src={props.mStudentDetails[0].student_img_path} 
                  alt=""
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div style={{
                position: 'absolute',
                bottom: '-4px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: COLORS.primary_color_shade5,
                color: '#fff',
                padding: '2px 8px',
                borderRadius: '999px',
                fontSize: '10px',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
              }}>
                {props.mStudentDetails[0].student_enrollment_no}
              </div>
            </div>

            {/* Student Details */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <h5 style={{
                margin: 0,
                marginBottom: '6px',
                fontSize: '16px',
                fontWeight: 600,
                color: '#111827',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}>
                <i className="fa fa-user" style={{ color: COLORS.primary_color_shade5, fontSize: '14px' }} />
                {props.mStudentDetails[0].stu_name}
              </h5>
              <p style={{
                margin: 0,
                marginBottom: '4px',
                fontSize: '13px',
                color: '#6b7280',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}>
                <i className="fa fa-male" style={{ color: '#9ca3af', fontSize: '12px' }} />
                <span style={{ fontWeight: 500 }}>Father:</span> {props.mStudentDetails[0].father_name}
              </p>
              <p style={{
                margin: 0,
                fontSize: '12px',
                color: '#6b7280',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}>
                <i className="fa fa-map-marker" style={{ color: '#9ca3af', fontSize: '12px' }} />
                <span style={{ fontWeight: 500 }}>Address:</span> 
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {props.mStudentDetails[0].current_address}
                </span>
              </p>
            </div>

            {/* Roll No & Class */}
            <div style={{
              flexShrink: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '6px',
              paddingLeft: '12px',
              borderLeft: '1px solid #e5e7eb',
            }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: `linear-gradient(135deg, ${COLORS.primary_color_shade5}, ${COLORS.primary_color_shade7})`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '18px',
                fontWeight: 700,
                boxShadow: '0 2px 8px rgba(3,169,244,0.25)',
              }}>
                {props.mStudentDetails[0].class[0].student_roll_no}
              </div>
              <span style={{
                background: COLORS.primary_color_shade5,
                color: '#fff',
                borderRadius: '999px',
                padding: '4px 10px',
                fontSize: '11px',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}>
                {props.mStudentDetails[0].class[0].class_name}
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: 'flex',
            gap: '8px',
            padding: '10px 16px',
            borderTop: '1px solid #f3f4f6',
            background: '#fafbfc',
          }}>
            <Link 
              to={{pathname:'/AdminMain/FeeCard'}} 
              style={{ 
                textDecoration: 'none',
                flex: 1,
                minWidth: 0,
              }}
            >
              <div style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: '999px',
                background: COLORS.primary_color_shade5,
                color: '#fff',
                fontSize: '13px',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = COLORS.primary_color_shade6;
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(3,169,244,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = COLORS.primary_color_shade5;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <i className="fa fa-credit-card" style={{ fontSize: '12px' }} />
                <span>Fee Card</span>
              </div>
            </Link>
            <Link 
              to={
                "/AdminMain/PaymentHistory/" +
                props.mStudentDetails[0].student_enrollment_no +
                "/" +
                props.mStudentDetails[0].class[0].session_id +
                "/" +
                encodeURIComponent(
                  props.mStudentDetails[0].class[0].session_name ||
                    props.mStudentDetails[0].class[0].session_id ||
                    "Session"
                )
              }
              style={{ 
                textDecoration: 'none',
                flex: 1,
                minWidth: 0,
              }}
            >
              <div style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: '999px',
                background: COLORS.primary_color_shade5,
                color: '#fff',
                fontSize: '13px',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = COLORS.primary_color_shade6;
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(3,169,244,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = COLORS.primary_color_shade5;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <i className="fa fa-history" style={{ fontSize: '12px' }} />
                <span>Payment History</span>
              </div>
            </Link>
            {props.action_advanced_payment ? (
            <div
              role="button"
              tabIndex={0}
              onClick={() => {
                const student = props.mStudentDetails?.[0];
                const classInfo = student?.class?.[0];
                props.action_advanced_payment(
                  student?.student_enrollment_no,
                  classInfo?.session_id
                );
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  const student = props.mStudentDetails?.[0];
                  const classInfo = student?.class?.[0];
                  props.action_advanced_payment(
                    student?.student_enrollment_no,
                    classInfo?.session_id
                  );
                }
              }}
              style={{ 
                flex: 1,
                minWidth: 0,
              }}
            >
              <div style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: '999px',
                background: COLORS.green_dark,
                color: '#fff',
                fontSize: '13px',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#2a9d2e';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(51,181,54,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = COLORS.green_dark;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <i className="fa fa-money-bill-wave" style={{ fontSize: '12px' }} />
                <span>Advanced Collection</span>
              </div>
            </div>
            ) : (
            <Link 
              to={'/AdminMain/AdvancedPayment/'+props.mStudentDetails[0].student_enrollment_no+"/"+props.mStudentDetails[0].class[0].session_id+"/"+current_due}
              style={{ 
                textDecoration: 'none',
                flex: 1,
                minWidth: 0,
              }}
            >
              <div style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: '999px',
                background: COLORS.green_dark,
                color: '#fff',
                fontSize: '13px',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#2a9d2e';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(51,181,54,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = COLORS.green_dark;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <i className="fa fa-money-bill-wave" style={{ fontSize: '12px' }} />
                <span>Advanced Collection</span>
              </div>
            </Link>
            )}
            <Link 
              to={'/AdminMain/Settlement/'+props.mStudentDetails[0].student_enrollment_no+"/"+props.mStudentDetails[0].class[0].session_id}
              style={{ 
                textDecoration: 'none',
                flex: 1,
                minWidth: 0,
              }}
            >
              <div style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: '999px',
                background: COLORS.card_orange,
                color: '#fff',
                fontSize: '13px',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = COLORS.card_burnt_orange;
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(224,122,47,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = COLORS.card_orange;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <i className="fa fa-handshake-o" style={{ fontSize: '12px' }} />
                <span>Settlement</span>
              </div>
            </Link>
            <Link 
              to={'/AdminMain/ManageFeeStructure/'+props.mStudentDetails[0].student_enrollment_no+"/"+props.mStudentDetails[0].class[0].session_id}
              style={{ 
                textDecoration: 'none',
                flex: 1,
                minWidth: 0,
              }}
            >
              <div style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: '999px',
                background: COLORS.Deep_Purple5,
                color: '#fff',
                fontSize: '13px',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = COLORS.Deep_Purple6;
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(103,58,183,0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = COLORS.Deep_Purple5;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <i className="fa fa-cog" style={{ fontSize: '12px' }} />
                <span>Manage Fee Structure</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default StudentInformation;

